import { PermissionActions } from '@/features/permissions/permissionActions.js'
import SuperAdminDummyRouter from '@/features/superAdmin/SuperAdminDummyRouter.vue'

export const roleManagementRoutes = [
  {
    path: 'role-management',
    component: SuperAdminDummyRouter,
    meta: { permissionAction: PermissionActions.RolesView },
    children: [
      {
        path: '',
        component: () =>
          import('@/features/settingsManagement/roleManagement/RolesEditView/RolesEditView.vue'),
        meta: { permissionAction: PermissionActions.RolesView },
      },
      {
        path: ':roleId',
        component: () =>
          import('@/features/settingsManagement/roleManagement/RolesEditView/RoleAPIAssignView.vue'),
        meta: { permissionAction: PermissionActions.RolesView },
      },
    ],
  },
]
